'use strict';

exports.__esModule = true;
exports._resetCookieCache = exports._notifyWatchers = exports.watchCookie = exports.setCookie = exports.getCookieValues = exports.getCookieValue = exports.getCookieObj = exports.getCookieKeys = exports.findCookie = exports.checkCookiesEnabled = undefined;

var _browser = require('./browser');

var _object = require('./object');

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// used to avoid parsing the same string multiple times
var cookieCacheStr = void 0;
var cookieCacheObj = void 0;

var setCookie = function setCookie(name, value, minutes, path) {
  var sameSite = _config2.default.get('tcc.cookies.sameSite') || '';
  var date = new Date();
  date.setTime(date.getTime() + minutes * 60 * 1000);

  (0, _browser.getDocument)().cookie = name + '=' + encodeURI(value) + '; domain=' + (0, _browser.getBaseHost)() + '; ' + (minutes ? 'expires=' + date.toGMTString() + '; ' : '') + (path ? 'path=' + path + '; ' : '') + (sameSite ? 'SameSite=' + sameSite + '; ' : '') + (sameSite.toUpperCase() === 'NONE' ? ' Secure;' : '');
};

/**
 * @param {string} name - Name of the cookie to lookup
 * @returns {string | undefined} - If found, returns the cookie value as a string
 */
var findCookie = function findCookie(name) {
  var cookieStr = (0, _browser.getDocument)().cookie;
  if (cookieCacheStr !== cookieStr) {
    cookieCacheObj = (0, _browser.parseCookie)(cookieStr);
    cookieCacheStr = cookieStr;
  }
  return cookieCacheObj[name];
};

var getCookieValues = function getCookieValues(cookieName) {
  // Returns cookie data as key/value pairs
  var cookie = findCookie(cookieName);
  return (0, _object.parseString)(cookie, '&', '=');
};

var getCookieValue = function getCookieValue(cookieName, key) {
  var val = getCookieValues(cookieName);
  if (val.hasOwnProperty(key)) {
    return val[key];
  }
};

var checkCookiesEnabled = function checkCookiesEnabled(nav) {
  var cookieEnabled = !!nav.cookieEnabled;
  if (typeof nav.cookieEnabled === 'undefined' && !cookieEnabled) {
    setCookie((0, _browser.getDocument)(), 'testcookie');
    cookieEnabled = (0, _browser.getDocument)().cookie.indexOf('testcookie') !== -1;
  }
  return cookieEnabled;
};

// Used to get and parse json blobs from cookies
var getCookieObj = function getCookieObj(cookieName) {
  var foundCookie = findCookie(cookieName);

  try {
    foundCookie = JSON.parse(foundCookie);
    return foundCookie;
  } catch (err) {
    return;
  }
};

// Returns an array containing all cookie keys
var getCookieKeys = function getCookieKeys() {
  var keys = [];
  var cookies = (0, _browser.getDocument)().cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var key = cookies[i].split('=')[0];
    if (key === '') continue;
    keys.push(key.trim());
  }
  return keys;
};

var _cookieVal = void 0;
var _watchCookieInterval = void 0;
var _cookieChangeCallbacks = [];

// Notifies all watchers that a cookie has changed
// Will remove a watcher if the callback is successful
var _notifyWatchers = function _notifyWatchers() {
  for (var i = 0; i < _cookieChangeCallbacks.length; i++) {
    try {
      var result = _cookieChangeCallbacks[i]();
      // Remove the watcher if callback returns with success
      if (result === true) {
        _cookieChangeCallbacks.splice(i, 1);
      }
    } catch (ex) {
      continue;
    }
  }
};

// Registers a callback fn that will be called whenever a cookie is modified on the page
var watchCookie = function watchCookie(fn) {
  // Call the callback immediately to see if there is a successful return
  var result = fn();

  // If successful, do not register the callback
  if (result === true) {
    return;
  }

  // Register the callback
  _cookieChangeCallbacks.push(fn);

  // If this is the first watcher, create an interval
  if (_cookieChangeCallbacks.length === 1) {
    _watchCookieInterval = setInterval(function () {
      // If the cookie has changed, notify watchers
      if (_cookieVal !== (0, _browser.getDocument)().cookie) {
        _cookieVal = (0, _browser.getDocument)().cookie;
        _notifyWatchers();
      }

      // If there are no more watchers, stop the interval
      if (_cookieChangeCallbacks.length === 0) {
        clearInterval(_watchCookieInterval);
      }
    }, 200);
  }
};

var _resetCookieCache = function _resetCookieCache() {
  cookieCacheStr = undefined;
  cookieCacheObj = Object.create(null);
};

exports.checkCookiesEnabled = checkCookiesEnabled;
exports.findCookie = findCookie;
exports.getCookieKeys = getCookieKeys;
exports.getCookieObj = getCookieObj;
exports.getCookieValue = getCookieValue;
exports.getCookieValues = getCookieValues;
exports.setCookie = setCookie;
exports.watchCookie = watchCookie;

// Private exports for testing

exports._notifyWatchers = _notifyWatchers;
exports._resetCookieCache = _resetCookieCache;